import { Button, Card } from '@/components';
import { useNews } from '@/components/providers/postauth/NewsProvider';
import { URLS } from '@/utils/constants';
import { useRouter } from 'next/router';
import { FC } from 'react';
import NewsList from './NewsList';
interface NewsCardProps {
  articleCountToShow?: number;
}
const NewsCard: FC<NewsCardProps> = ({ articleCountToShow = 5 }) => {
  const router = useRouter();
  const { news, isLoading } = useNews();
  const handleSeeAllNews = () => {
    router.push(URLS.allNews);
  };
  const NewsCardFooter: FC = () => {
    if (news.length > 0) {
      return (
        <Card.Footer>
          <Button intent="ghost" onClick={handleSeeAllNews}>
            See all
          </Button>
        </Card.Footer>
      );
    }
    return null;
  };
  return (
    <Card>
      <Card.Header
        title="Latest News"
        loading={isLoading}
        right={
          news.length > 0 && (
            <Button intent="ghost" onClick={handleSeeAllNews}>
              See all
            </Button>
          )
        }
      />
      <Card.Body>
        <NewsList limit={articleCountToShow} includeMetadata={true} />
      </Card.Body>
    </Card>
  );
};
export default NewsCard;
